export default function ImmersiveBackground({
  src,
  mobileSrc,
  focus = "50% 20%",
}: {
  src: string;
  mobileSrc?: string;
  focus?: string;
}) {
  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      <picture className="block h-full w-full">
        {mobileSrc && <source media="(min-width: 768px)" srcSet={src} />}
        <img
          src={mobileSrc ?? src}
          alt=""
          className="h-full w-full object-cover"
          style={{ objectPosition: focus }}
          fetchPriority="high"
          decoding="async"
        />
      </picture>
      <div className="nm-grain absolute inset-0" />
      <div className="absolute inset-0 bg-gradient-to-r from-[var(--nm-bg)]/92 via-[var(--nm-bg)]/62 to-[var(--nm-bg)]/28" />
      <div className="absolute inset-0 bg-gradient-to-b from-[var(--nm-bg)]/18 via-transparent to-[var(--nm-bg)]" />
    </div>
  );
}
